export default __webpack_public_path__ + "static/media/product3.9fae8cf0.png";